import JSConfetti from 'js-confetti'
import { useEffect } from 'react'

interface UseConfettiOptions {
  /** Whether the confetti should be triggered */
  trigger: boolean
  /** Custom confetti colors - defaults to Thatch brand colors */
  colors?: string[]
}

/**
 * Custom hook to trigger confetti animation
 * @param options Configuration options for the confetti
 */
export function useConfetti ({ trigger, colors }: UseConfettiOptions) {
  const defaultColors = [
    '#9C3BFF', // thatch-500
    '#FFC879', // orange-300
    '#0094D5', // blue-400
    '#8051FF', // violet-400
    '#EC3939', // red-400
    '#FFE655', // yellow-300
    '#47CA67', // green-300
  ]

  useEffect(() => {
    if (trigger) {
      const confetti = new JSConfetti()
      confetti.addConfetti({
        confettiColors: colors ?? defaultColors,
      })

      return () => {
        confetti.destroyCanvas()
      }
    }
  }, [trigger, colors])
}
